import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TableTotal from './TableTotal';

interface TableDataRow {
  [key: string]: any;
  email?: string;
  userId?: string;
}

interface Props {
  tableData: any;
  columns: {
    label: string;
    accessor: string;
    sortable: boolean;
    tooltip?: string;
    renderTooltip?: (data: TableDataRow) => string | null;
  }[];
  totals?: [];
}
const TableBody = ({ tableData, columns, totals }: Props) => {
  return (
    <tbody>
      {tableData.map((data: any, i: any) => {
        return (
          <tr key={`${data[0]}-${i}`}>
            {columns.map(({ accessor, renderTooltip }) => {
              const tData = data[accessor] ? data[accessor] : '0';
              const tooltipContent = renderTooltip ? renderTooltip(data) : null;

              if (tooltipContent) {
                return (
                  <td key={accessor}>
                    <OverlayTrigger
                      placement='top'
                      delay={{ show: 250, hide: 400 }}
                      overlay={<Tooltip id={`tooltip-${accessor}-${i}`}>{tooltipContent}</Tooltip>}
                      onToggle={(show) => {
                        if (show) {
                          console.log(`${tData}: ${tooltipContent}`);
                        }
                      }}
                    >
                      <span>{tData}</span>
                    </OverlayTrigger>
                  </td>
                );
              }

              return <td key={accessor}>{tData}</td>;
            })}
          </tr>
        );
      })}
      {totals && <TableTotal totals={totals} />}
    </tbody>
  );
};

export default TableBody;
